module.exports = __webpack_public_path__ + "img/baoming.1641520899224.png";